// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NsWq","content":"styles_content__117Ni"};